import { loadStripe } from "@stripe/stripe-js";
import api from "@/lib/api";

let _promise = null;

// Fetches the publishable key from the backend once, then loads Stripe.
// The returned promise resolves directly to a Stripe instance.
export function getStripePromise() {
  if (!_promise) {
    _promise = api.get("/config").then(({ data }) => loadStripe(data.publishable_key));
  }
  return _promise;
}
